import { IController } from 'angular';
import CanvasFreeDrawing from 'canvas-free-drawing';

/**
 * @type {IController}
 */
export default class FreeDrawController {
	/* @ngInject */
	constructor($timeout, $element) {
		this.cfd = null;

		this.color = '#000';
		this.width = null;
		this.height = null;

		this.$timeout = $timeout;
		this.$element = $element;
	}

	// eslint-disable-next-line class-methods-use-this
	hexToRGB(hex) {
		const result = /^#?([\da-f]{2})([\da-f]{2})([\da-f]{2})$/i.exec(hex);
		return result ? [
			Number.parseInt(result[1], 16),
			Number.parseInt(result[2], 16),
			Number.parseInt(result[3], 16),
		] : null;
	}

	// eslint-disable-next-line class-methods-use-this
	rgbToHex(r, g, b) {
		// eslint-disable-next-line no-bitwise
		return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`;
	}

	// eslint-disable-next-line class-methods-use-this
	$onChanges(changes) {
		//
	}

	// eslint-disable-next-line class-methods-use-this
	getCanvas() {
		return document.querySelector('#cfd');
	}

	setColor(color) {
		const rgb = this.hexToRGB(color);
		this.cfd.setStrokeColor([0, 0, 255]); // in RGB
	}

	redraw() {
		this.cfd = new CanvasFreeDrawing({
			elementId: 'cfd',
			width: this.width,
			height: this.height,
		});
	}

	$onInit() {
		this.$timeout(() => {
			console.log('clientWidth', this.$element.width());
			this.cfd = new CanvasFreeDrawing({
				elementId: 'cfd',
				width: this.$element.width(),
				height: this.$element.height(),
			});
		});
	}
}
